import Cookies from 'js-cookie';
import posthog from 'posthog-js'

import './trial';
import './login';
import './swapping-text';
import './blog-cta-bar';
import '../scss/app.scss';

const $ = jQuery;

$(document).ready(function() {
	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });

    $('.fluid-width-video-wrapper').removeClass('hidden');

    $('a.modal-open').featherlight({
        targetAttr: 'href',
        persist: true,
    });

    $('a.modal-iframe-open').featherlight({
        targetAttr: 'href',
        persist: true,
        type: 'iframe',
        afterContent: () => {
            $('.featherlight-content').find('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });
        },
    });
});

// Toggle
$('.js-toggle-trigger').bind('click', function(e) {
    e.preventDefault();
    jQuery(this).parent().find('.toggle-content').slideToggle('fast');
    jQuery(this).parent().toggleClass('is-expanded');
});

// Sliding panel
$(document).ready(function() {
    $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart', function(e) {
        e.preventDefault();
        $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
    });

    $('.sliding-panel-content li.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).parent().find('.sub-menu').removeClass('open');
        } else {
            $(this).addClass('open');
            $(this).parent().find('.sub-menu').addClass('open');
        }
    });

    const fixSliderLoop = (slick, nextSlide) => {
        const cls = 'slick-current slick-active slick-center';
        if (nextSlide === 0) {
            setTimeout(function() {
                slick.$slider.find('[data-slick-index="' + slick.$slides.length + '"]').addClass(cls).siblings().removeClass(cls);
                for (let i = slick.options.slidesToShow - 1; i >= 0; i--) {
                    slick.$slider.find('[data-slick-index="' + i + '"]').addClass(cls);
                }
            }, 10);
        }
        if (nextSlide === slick.$slides.length - 1) {
            setTimeout(function() {
                slick.$slider.find('[data-slick-index="' + nextSlide + '"]').addClass(cls).siblings().removeClass(cls);
                for (let i = -1; i >= -1 * slick.options.slidesToShow; i--) {
                    slick.$slider.find('[data-slick-index="' + i + '"]').addClass(cls);
                }
            }, 10);
        }
    }

    const $shortTestimonialsSlider = $('.section-short-testimonials.with-slider .short-testimonials-wrapper');
	$shortTestimonialsSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 7000,
	});

    const $testimonialsSlider = $('.testimonials-slider');
	$testimonialsSlider.slick({
        centerMode: true,
        variableWidth: window.innerWidth >= 1024,
		slidesToShow: 1,
		slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendArrows: $('.section-testimonials .section-header .slider-nav'),
        infinite: true,
        autoplay: true,
        autoplaySpeed: 7000,
	});
    $testimonialsSlider.on('init', function() {
        $('.section-testimonials .testimonial').show();
    });

    $testimonialsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });

    const $rotatingTexts = $('.rotating-texts');
    $rotatingTexts.on('init', function() {
        $('.section-g2-slider .g2-slider-slide').removeClass('hidden');
    });
	$rotatingTexts.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
	});

    $rotatingTexts.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });

    const $logosSlider = $('.logos-slider');
	$logosSlider.slick({
		slidesToShow: 8,
		slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        pauseOnHover: $logosSlider.hasClass('logos-slider-pause-on-hover'),
        speed: 2000,
        autoplaySpeed: 0,
        infinite: true,
        cssEase: 'linear',
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 6
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
        ],
	});
    $logosSlider.on('init', function() {
        $('.section-logos .logo').show();
    });

    $logosSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });

    const $badgesSlider = $('.badges-slider');
	$badgesSlider.slick({
		slidesToShow: 8,
		slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 0,
        infinite: true,
        cssEase: 'linear',
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 7
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 6
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
        ]
	});

    $badgesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });

    const $iconsSlider = $('.icons-slider');
	$iconsSlider.slick({
		slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.icons-nav-slider'
	});

    $iconsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        fixSliderLoop(slick, nextSlide);
    });

    const $iconsNavSlider = $('.icons-nav-slider');
	$iconsNavSlider.slick({
		slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: '.icons-slider',
        arrows: true,
        centerMode: true,
        centerPadding: '0',
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 6
              }
            },
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
        ]
	});
});

// Vertical tabs
$('.js-vertical-tab-content').hide();
$('.js-vertical-tab-content:first').show();

const updateChevrons = () => {
    $('.vertical-tabs-container-toggles .vertical-tab-accordion-heading .icon-wrapper i').removeClass('fa-circle-chevron-up').addClass('fa-circle-chevron-down');
    $('.vertical-tabs-container-toggles .vertical-tab .icon-wrapper i').removeClass('fa-circle-chevron-up').addClass('fa-circle-chevron-down');
    $('.vertical-tabs-container-toggles .vertical-tab-accordion-heading.is-active .icon-wrapper i').removeClass('fa-circle-chevron-down').addClass('fa-circle-chevron-up');
    $('.vertical-tabs-container-toggles .vertical-tab.is-active .icon-wrapper i').removeClass('fa-circle-chevron-down').addClass('fa-circle-chevron-up');
};

/* if in tab mode */
$('.js-vertical-tab').click(function() {
    if ($(this).hasClass('is-active')) {
        return;
    }

    const currentTab = $('.js-vertical-tab.is-active').attr('rel');
	const activeTab = $(this).attr('rel');

    if ($(this).hasClass('vertical-tab-with-icon')) {
        $('#' + currentTab).fadeOut(300, function() {
            $('#' + activeTab).fadeIn(300);
        });
    } else {
        $('.js-vertical-tab-content').hide();
        $('#' + activeTab).show();
    }

	$('.js-vertical-tab-accordion-heading').removeClass('is-active');
	$('.js-vertical-tab-accordion-heading[rel^="' + activeTab + '"]').addClass('is-active');

    if ($(this).hasClass('vertical-tab-with-icon')) {
        $('.js-vertical-tab.is-active .tab-text').slideUp(300);
        $('.js-vertical-tab[rel^="' + activeTab + '"] .tab-text').slideDown(300, function() {
            $('.js-vertical-tab').removeClass('is-active');
            $('.js-vertical-tab[rel^="' + activeTab + '"]').addClass('is-active');
            updateChevrons();
        });
    } else {
        $('.js-vertical-tab').removeClass('is-active');
        $('.js-vertical-tab[rel^="' + activeTab + '"]').addClass('is-active');
        updateChevrons();
    }
});

/* if in accordion mode */
$('.js-vertical-tab-accordion-heading').on('mouseover, click', function(e) {
    if ($(this).hasClass('is-active')) {
        return;
    }

    e.preventDefault();

	const accordion_activeTab = $(this).attr('rel');
    $('.js-vertical-tab-content').hide();
    $('#' + accordion_activeTab).show();

    $('.js-vertical-tab-accordion-heading').removeClass('is-active');
	$(this).addClass('is-active');

	$('.js-vertical-tab').removeClass('is-active');
	$('.js-vertical-tab[rel^="' + accordion_activeTab + '"]').addClass('is-active');

    updateChevrons();
});

// Horizontal tabs
$('.js-horizontal-tab').click(function() {
    if ($(this).hasClass('is-active')) {
        return;
    }

    const id = $(this).attr('rel');
    $('.js-horizontal-tab').removeClass('is-active');
    $(this).addClass('is-active')
    $('.js-horizontal-tab-content').removeClass('is-active');
    $('.js-horizontal-tab-content#' + id).addClass('is-active');

    if (window.innerWidth < 768) {
        $('html, body').animate({
            scrollTop: $(this).closest('ul.horizontal-tabs').offset().top - 100,
        }, 800);
    }
});

const fitBoxTitles = (selector, threeColumns = false) => {
    let maxHeight = 0;
    let columns = 1;
    if (window.innerWidth >= 1280 && threeColumns) {
        columns = 3;
    } else if (window.innerWidth >= 768) {
        columns = 2;
    }
    if (columns == 1) {
        return;
    }
    let column = 0;
    let row = 0;
    let rows = [];
    $(selector).each(function() {
        column += 1;
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
        if (column % columns === 0) {
            rows[row] = maxHeight;
            row += 1;
            maxHeight = 0;
        }
    });
    if (column % columns !== 0) {
        rows[row] = maxHeight;
    }
    column = 0;
    row = 0;
    $(selector).each(function() {
        const height = rows[row];
        $(this).height(height);
        column += 1;
        if (column % columns === 0) {
            row += 1;
        }
    });
};

$(document).ready(function() {
    fitBoxTitles('article.post-wrapper.type-post h3', true);
    fitBoxTitles('article.post-wrapper.type-news h3');
    fitBoxTitles('.jobs-item .job-header h3');
});

$(document).ready(function() {
    $.mark = {
        jump: function (options) {
            const defaults = {
                selector: 'li.menu-item a'
            };
            if (typeof options == 'string') {
                defaults.selector = options;
            }

            options = $.extend(defaults, options);
            return $(options.selector).click(function (e) {
                const jumpobj = $(this);
                const target = jumpobj.attr('href');
                if (target == '#') {
                    e.preventDefault();
                    return;
                }
                if (target.indexOf('#') < 0) {
                    return;
                }
                const offset = $(target).offset().top - $('#wpadminbar').outerHeight() - $('.navigation').outerHeight() + 1;
                const thespeed = 1000;
                $('html,body').animate({
                    scrollTop: offset
                }, thespeed, 'swing');
                e.preventDefault();
            });
        }
    };
});

$(document).ready(function() {
    jQuery.mark.jump();
});

const popupCenter = (url, w, h) => {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(url, "_blank",
      `
      scrollbars=yes,
      status=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
    );

    if (window.focus) {
        newWindow.focus();
    }
}

$('.share-social a').click(function(e) {
    e.preventDefault();
    popupCenter($(this).attr('href'), 570, 520);
});

$('.section-pricing input[name="switch-price"]').change(function(e) {
    if (e.target.checked) {
        $('.section-pricing .price-month').addClass('hidden');
        $('.section-pricing .price-year').removeClass('hidden');
    } else {
        $('.section-pricing .price-month').removeClass('hidden');
        $('.section-pricing .price-year').addClass('hidden');
    }
});

$(document).on('gform_confirmation_loaded', function(e, formId) {
    if (formId == 3) {
        $('.trial-notification-content').hide();
    }
});

const utmTags = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
];

$(document).ready(function() {
    const searchParams = new URLSearchParams(location.search);
    utmTags.forEach((tag) => {
        if (searchParams.get(tag)) {
            Cookies.set('_sp_' + tag, searchParams.get(tag), { expires: 30 });
        }
    });
});

$(document).ready(function() {
    utmTags.forEach((tag) => {
        const tagValue = Cookies.get('_sp_' + tag);
        if (tagValue && $(`input[name="${tag}"]`).length > 0) {
            $(`input[name="${tag}"]`).val(tagValue).trigger('change');
        }
    });
});

$(document).ready(function() {
    if ($('.gform_wrapper').length === 0) {
        return;
    }

    utmTags.forEach((tag) => {
        const value = Cookies.get('_sp_' + tag);
        if (value) {
            const el = $('input[data-prefill="' + tag + '"]');
            if (el) {
                el.val(value).trigger('change');
            }
        }
    });
});

$(document).ready(function() {
    if ($('.stockpress-trial-form').length === 0) {
        return;
    }

    utmTags.forEach((tag) => {
        const value = Cookies.get('_sp_' + tag);
        if (value) {
            const el = $('input[name="' + tag + '"]');
            if (el) {
                el.val(value).trigger('change');
            }
        }
    });
});

$('body').on('click', 'a', function(e) {
    if ($(this).attr('href') && $(this).attr('href').indexOf('#') === 0) {
        if ($($(this).attr('href')).length > 0) {
            e.preventDefault();
            const landingNav = $('header.landing-navigation');
            let navOffset = 0;
            if (landingNav.length > 0) {
                navOffset = landingNav.height();
            }
            $('html, body').animate({
                scrollTop: $($(this).attr('href')).offset().top - 20 - navOffset
            }, 800);
        }
    }
});

$(document).ready(function() {
    const stickyLanding = $('.landing-navigation').length > 0;
    const stickySection = $('.section-navigation-sticky').length > 0;

    if (!stickyLanding && !stickySection) {
        return;
    }

    const stickySectionPosition = stickySection ? $('.section-navigation-sticky').offset().top : 0;

    $(window).scroll(function () {
        const scrollTop = $(window).scrollTop();
        let offset = 100;
        let wpAdminBarHeight = 0;
        let topBarHeight = 0;
        if ($('#wpadminbar').length) {
            wpAdminBarHeight = $('#wpadminbar').height();
        }
        if ($('.top-bar').length) {
            topBarHeight = $('.top-bar').height();
        }
        offset += wpAdminBarHeight;
        if (stickySection) {
            offset = stickySectionPosition;
        }
        if (scrollTop > offset) {
            if (stickyLanding) {
                $('header.landing-navigation').addClass('sticky');
                $('.top-bar').addClass('hidden');
                $('body').css('margin-top', $('header.landing-navigation').outerHeight());
                $('header.landing-navigation').css('top', wpAdminBarHeight);
            }
            if (stickySection) {
                $('section.section-navigation-sticky').addClass('sticky');
                $('.top-bar').addClass('hidden');
                $('body').css('margin-top', $('section.section-navigation-sticky').outerHeight());
                $('section.section-navigation-sticky').css('top', wpAdminBarHeight);
            }
        } else {
            if (stickyLanding) {
                $('header.landing-navigation').removeClass('sticky');
                $('.top-bar').removeClass('hidden');
                $('body').css('margin-top', 0);
                $('header.landing-navigation').css('top', 0);
            }
            if (stickySection) {
                $('section.section-navigation-sticky').removeClass('sticky');
                $('.top-bar').removeClass('hidden');
                $('body').css('margin-top', 0);
                $('section.section-navigation-sticky').css('top', 0);
            }
        }
    });
});

// Tabs
$(document).ready(function () {
    $('.tabs').each(function(index) {
        $(this).children('li').first().children('a').addClass('is-active').next().addClass('is-open').show();
    });
    $('.tabs').on('click', 'li > a.tab-link', function(event) {
        if (!$(this).hasClass('is-active')) {
            event.preventDefault();
            var accordionTabs = $(this).closest('.tabs');
            accordionTabs.find('.is-open').removeClass('is-open').hide();

            $(this).next().toggleClass('is-open').toggle();
            accordionTabs.find('.is-active').removeClass('is-active');
            $(this).addClass('is-active');
        } else {
            event.preventDefault();
        }
    });
});

const openIntercomMessages = () => {
    if (window.Intercom) {
        window.Intercom('showMessages');
    }
};

// Pricing dropdowns
const prices2023 = {
    year: {
        t50gb: '$49',
        t100gb: '$89',
        t500gb: '$225',
        t1tb: '$425',
        t3tb: '$965',
        t5tb: '$1,610',
        p500gb: '$270',
        p1tb: '$515',
        p3tb: '$1,155',
        p5tb: '$1,930',
    },
    month: {
        t50gb: '$59',
        t100gb: '$99',
        t500gb: '$250',
        t1tb: '$475',
        t3tb: '$1,070',
        t5tb: '$1,785',
        p500gb: '$300',
        p1tb: '$570',
        p3tb: '$1,285',
        p5tb: '$2,145',
    },
};

const prices2024 = {
    year: {
        b200gb: '$79',
        t500gb: '$145',
        t1tb: '$225',
        t3tb: '$375',
        p500gb: '$195',
        p1tb: '$295',
        p3tb: '$565',
        p5tb: '$995',
        p10tb: '$1,885',
    },
    month: {
        b200gb: '$87',
        t500gb: '$160',
        t1tb: '$248',
        t3tb: '$413',
        p500gb: '$215',
        p1tb: '$325',
        p3tb: '$625',
        p5tb: '$1,095',
        p10tb: '$2,074',
    },
};

const prices2025 = {
    year: {
        b200gb: '$99',
        t500gb: '$175',
        t1tb: '$265',
        t3tb: '$445',
        p500gb: '$225',
        p1tb: '$345',
        p3tb: '$660',
        p5tb: '$995',
        p10tb: '$1,885',
    },
    month: {
        b200gb: '$108',
        t500gb: '$192',
        t1tb: '$291',
        t3tb: '$489',
        p500gb: '$247',
        p1tb: '$379',
        p3tb: '$726',
        p5tb: '$1,095',
        p10tb: '$2,074',
    },
};

jQuery(document).ready(function() {
    const lastSelectedValue = {};

    let prices = prices2023;
    if ($('.section-pricing-new-2024').length > 0) {
        prices = prices2025;
    }

    const updatePrices = (period) => {
        const keys = Object.keys(prices[period]);
        $('.fsb-option:not(:contains("Contact"))').each(function(idx, el) {
            const price = prices[period][keys[idx]];
            const poption = $(el).find('span');
            const html = $(poption).html().replace(/\([^()]*\)/g, `(${price}/month)`);
            $(poption).html(html);
            if ($(el).attr('aria-selected') === 'true') {
                const button = $(el).closest('.fsb-select').find('.fsb-button span');
                $(button).html(html);
            }
        });
        keys.forEach((key) => {
            if ($('.price-details .price#' + key).length > 0) {
                $('.price-details .price#' + key).html(prices[period][key] + '/month');
            }
        });
    };

    const updateFancySelectOptions = () => {
        $('.fsb-option, .fsb-button').each(function() {
            const html = $(this).html().replace('&nbsp;&nbsp;', '<del>').replace('&nbsp;&nbsp;', '</del>').replace('&nbsp;', '<strong>').replace('&nbsp;', '</strong>');
            $(this).html(html);
        });
    };
    updateFancySelectOptions();

    const updatePrice = (id) => {
        const period = $('#period-switcher').is(':checked') ? 'year' : 'month';
        const pricingType = $('.pricing-discount-switch li.selected').data('pricing-type');
        let price = prices[period][$('#' + id).val()];
        if (pricingType === 'nonprofit') {
            price = parseInt(prices[period][$('#' + id).val()].replace('$', '').replace(',', ''));
            price = '$' + new Intl.NumberFormat('us-US', { minimumFractionDigits: 2 }).format(price * 0.7);
        }
        $('#' + id + '-value').html(price + '/month');
    };

    $('#period-switcher').on('change', function(e) {
        updatePrices(e.target.checked ? 'year' : 'month');
        $('select').each(function() {
            updatePrice($(this).attr('id'));
        });
    });

    $('select').each(function() {
        lastSelectedValue[$(this).attr('id')] = $(this).val();
        updatePrice($(this).attr('id'));
    });

    $('select').on('change', function(e) {
        if (e.target.value === 'contact') {
            openIntercomMessages();
            $(this).val(lastSelectedValue[$(this).attr('id')]);
            FancySelect.update(document.getElementById($(this).attr('id')));
            updateFancySelectOptions();
        } else {
            lastSelectedValue[$(this).attr('id')] = $(this).val();
            updatePrice($(this).attr('id'));
        }
    });

    $('.pricing-discount-switch').on('click', 'a', function(e) {
        e.preventDefault();
        $('.pricing-discount-switch li').removeClass('selected');
        $(this).parent('li').addClass('selected');
        $('select').each(function() {
            updatePrice($(this).attr('id'));
        });
    });

    $('button.features-show-more').on('click', function(e) {
        e.preventDefault();
        $('tr.feature-row-hidden').removeClass('hidden');
        $(this).addClass('hidden');
        $('button.features-show-less').removeClass('hidden');
    });
    $('button.features-show-less').on('click', function(e) {
        e.preventDefault();
        $('tr.feature-row-hidden').addClass('hidden');
        $(this).addClass('hidden');
        $('button.features-show-more').removeClass('hidden');
        $('html,body').animate({
            scrollTop: $('.section-features-comparison-responsive .features-wrapper').offset().top - $('.navigation').outerHeight() - 50,
        }, 500, 'swing');
    });
});

$('#intercom-contact,a[href="#intercom-contact"]').on('click', function(e) {
    e.preventDefault();
    openIntercomMessages();
});

$(document).ready(function() {
    $('section.section-fake-modal.full-height').each(function() {
        $(this).css('height', 'calc(100vh - ' + (jQuery('#wpadminbar').outerHeight() || 0) + 'px)');
    });
});

$(document).ready(function() {
    $('video').each(function() {
        const v = document.getElementById($(this).attr('id'));
        if (v && v.attributes.bgvideo) {
            v.load();
            v.onloadeddata = function() {
                v.play();
            };
        }
    });
});

$(document).ready(function() {
    $('.menu-item.menu-item-has-children').on('mouseenter', function() {
        $('section').prepend('<div class="menu-overlay-active"></div>');
    });
    $('.menu-item.menu-item-has-children').on('mouseleave', function() {
        $('section .menu-overlay-active').remove();
    });
});

// Posthog
if (!window.location.host.includes('.local')) {
    posthog.init('phc_1Wed9SCQLOm0WULh50NnHp4WruKAw8OxYZtDjx2YXwV', {
        api_host: 'https://us.i.posthog.com',
        disable_session_recording: true,
    });
    window.posthog = posthog;
}



// WEBPACK FOOTER //
// ./src/js/app.js